import { render } from "./ImageComponent.vue?vue&type=template&id=3806c70e&ts=true"
import script from "./ImageComponent.vue?vue&type=script&lang=ts"
export * from "./ImageComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__